function AddressInput(props) {
  return <input {...props} className="w-full mb-2 px-2 py-2 text-sm border border-border outline-none focus:border-primary" />;
}

export default function PostalAddressFields({ exp, dest, setExpF, setDestF }) {
  return (
    <div className="mt-4 grid sm:grid-cols-2 gap-4">
      <div className="border border-border p-3">
        <div className="overline text-muted-foreground mb-2">Expéditeur (vous)</div>
        <AddressInput data-testid="exp-nom" value={exp.nom || ""} onChange={(e) => setExpF("nom", e.target.value)} placeholder="Nom *" />
        <AddressInput data-testid="exp-societe" value={exp.societe || ""} onChange={(e) => setExpF("societe", e.target.value)} placeholder="Société" />
        <AddressInput data-testid="exp-adresse" value={exp.adresse1 || ""} onChange={(e) => setExpF("adresse1", e.target.value)} placeholder="Adresse" />
        <div className="flex gap-2">
          <input data-testid="exp-cp" value={exp.cp || ""} onChange={(e) => setExpF("cp", e.target.value)} placeholder="CP *" className="w-24 px-2 py-2 text-sm border border-border outline-none focus:border-primary" />
          <input data-testid="exp-ville" value={exp.ville || ""} onChange={(e) => setExpF("ville", e.target.value)} placeholder="Ville *" className="flex-1 px-2 py-2 text-sm border border-border outline-none focus:border-primary" />
        </div>
      </div>
      <div className="border border-border p-3">
        <div className="overline text-muted-foreground mb-2">Destinataire</div>
        <AddressInput data-testid="dest-societe" value={dest.societe || ""} onChange={(e) => setDestF("societe", e.target.value)} placeholder="Société" />
        <AddressInput data-testid="dest-nom" value={dest.nom || ""} onChange={(e) => setDestF("nom", e.target.value)} placeholder="Nom (dirigeant)" />
        <AddressInput data-testid="dest-adresse" value={dest.adresse1 || ""} onChange={(e) => setDestF("adresse1", e.target.value)} placeholder="Adresse" />
        <div className="flex gap-2">
          <input data-testid="dest-cp" value={dest.cp || ""} onChange={(e) => setDestF("cp", e.target.value)} placeholder="CP *" className="w-24 px-2 py-2 text-sm border border-border outline-none focus:border-primary" />
          <input data-testid="dest-ville" value={dest.ville || ""} onChange={(e) => setDestF("ville", e.target.value)} placeholder="Ville *" className="flex-1 px-2 py-2 text-sm border border-border outline-none focus:border-primary" />
        </div>
      </div>
    </div>
  );
}
